import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

declare let $: any;
declare let AB: any;
declare let window: any;

@Component({
    selector: 'app-terms-content',
    templateUrl: './terms-content.component.html',
    styleUrls: ['./terms-content.component.scss']
})
export class TermsContentComponent implements OnInit {

    public text: string;
    public warning = false;
    public page: string;
    modalID = 'tooltipModal';
    modalSelector = '#' + this.modalID;
    public focused: any;
    public canShowModalFooter = true;
    @Input() title: any = "TERMS AND CONDITIONS";
    @Input() userSubscriptionDetails: any;
    @Input() userInfo: any;
    @Input() content: any;
    @Input() lastActiveEle: any;

    constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService, private hostElement: ElementRef) {
        this.returnFocus = this.returnFocus.bind(this);
    }

    ngOnInit() {
        this.text = this.content;
    }

    close() {
        this.bsModalRef.hide();
    }

    returnFocus() {
        if (this.lastActiveEle) {
            this.lastActiveEle.focus();
        }
    }

}
